import { render } from "./ContactPage.vue?vue&type=template&id=38262e5c&scoped=true&bindings={}"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=38262e5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38262e5c"

export default script